import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "drv-form-root drv-base-gs" }
const _hoisted_2 = { class: "row list-point-title" }
const _hoisted_3 = { class: "drv-ml-1 drv-text-body-md drv-text-weight-medium" }
const _hoisted_4 = {
  key: 0,
  class: "row list-point-action"
}
const _hoisted_5 = { class: "row list-point-action" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "row list-point-title drv-mt-3" }
const _hoisted_8 = { class: "drv-ml-1 drv-text-body-md drv-text-weight-medium" }
const _hoisted_9 = { class: "row list-point-action" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "row list-point-title drv-mt-3" }
const _hoisted_12 = { class: "drv-ml-1 drv-text-body-md drv-text-weight-medium" }
const _hoisted_13 = { class: "row list-point-action" }

import HelpLink from "../HelpLink.vue";
import { computed, ref, watch } from "vue";
import {
  EAuthTypes,
  ECommonMessages,
  EConnectionCheckStatus,
  EInsurerMessagesKeys,
  ETelematicsMessagesKeys,
  IGorillaSafetyBasic,
  IPlatform,
} from "../../../../types";
import { Input } from "draivn-ui-kit/components/input";
import {
  maxLengthValidator,
  minLengthValidator,
  regexpValidator,
  requiredValidator,
  skipOnEmptyValidator,
} from "draivn-ui-domain";
import { DOT_REGEXP, HELP_URL_BY_PLATFORM } from "../../../../constants";
import { useOnboardingStore } from "@/modules/onboarding";
import { postConnectionCheck } from "@/modules/onboarding/services";
import { injector } from "@/services";
import { I18N_SERVICE_INJECTION_KEY } from "@/constants";
import CheckConnection from "@/modules/onboarding/components/blocks/telematics/CheckConnection.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'GorillaSafetyBasic',
  props: {
    modelValue: {},
    platform: {},
    disable: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit =
  __emit;

const EMPTY_MODEL = {
  type: EAuthTypes.ACCOUNT,
  dotNumber: null,
  connectionApproved: false,
};

const requestAccessIsSent = ref<boolean>(false);
const showRequestAccessError = ref<boolean>(false);
const connected = ref<boolean>(false);
const showConnectedError = ref<boolean>(false);

if (props.modelValue?.connectionApproved && props.modelValue?.dotNumber) {
  requestAccessIsSent.value = true;
}

const i18n = injector.injectFromRoot(I18N_SERVICE_INJECTION_KEY);
const { t } = i18n.global;
const isLoading = ref<boolean>(false);
const step1Loading = ref<boolean>(false);
const errorBannerText = ref<string | null>(null);

const insurerUsdot = computed<string>(() => {
  let usdot: string | null =
    useOnboardingStore().model.sections?.insurer?.data?.customer?.usdot;
  return usdot?.length ? usdot : null;
});

const model = computed<IGorillaSafetyBasic>({
  get() {
    const result = props.modelValue ?? EMPTY_MODEL;
    if (result.dotNumber == null) {
      result.dotNumber = insurerUsdot.value != null ? insurerUsdot.value : "";
    }
    return result;
  },
  set(value: IGorillaSafetyBasic) {
    emit("update:modelValue", value);
  },
});

watch(insurerUsdot, (valueNew, valueOld) => {
  if (!dotNumber.value?.length || dotNumber.value == valueOld) {
    dotNumber.value = valueNew;
  }
});

const dotNumber = computed<string>({
  get() {
    return model.value?.dotNumber ?? "";
  },
  set(value: string) {
    model.value = { ...model.value, dotNumber: value };
  },
});
const showDot = ref<boolean>(insurerUsdot.value != dotNumber.value);

const connectionApproved = computed<boolean>({
  get() {
    return model.value?.connectionApproved ?? EMPTY_MODEL.connectionApproved;
  },
  set(value: boolean) {
    model.value = { ...model.value, connectionApproved: value };
  },
});

const onClickToActivateConnection = async () => {
  isLoading.value = true;
  step1Loading.value = true;
  showRequestAccessError.value = false;
  showConnectedError.value = false;
  try {
    const response = await postConnectionCheck({
      platform_type: props.platform.const,
      url: props.platform.methods[0].url,
      credentials: { ...model.value, requestAccess: true },
    });
    errorBannerText.value = "";
    if (
      response?.connected ||
      response?.status == EConnectionCheckStatus.PENDING
    ) {
      requestAccessIsSent.value = true;
      showRequestAccessError.value = false;
    } else {
      requestAccessIsSent.value = false;
      showRequestAccessError.value = true;
      showDot.value = true;
    }
  } catch (e) {
    requestAccessIsSent.value = false;
    showRequestAccessError.value = true;
    showDot.value = true;
  }
  isLoading.value = false;
  step1Loading.value = false;
};

const onUpdateConnected = (value: boolean | null) => {
  console.log("onUpdateConnected", value);
  if (value !== null) {
    showConnectedError.value = !value;
  }
};

const onConnectionApprovedClick = () => {
  showConnectedError.value = false;
  connected.value = false;
};

const currentText: { url: string } = {
  url: HELP_URL_BY_PLATFORM[props.platform.const],
};

const dotNumberControl = ref<typeof Input | null>(null);
const hasErrorStep1 = computed<boolean>(
  () => !dotNumber.value?.length || dotNumberControl.value?.hasError
);
const hasError = computed<boolean>(
  () => hasErrorStep1.value || !connectionApproved.value || !connected.value
);
__expose({
  hasError,
});

return (_ctx: any,_cache: any) => {
  const _component_d_input = _resolveComponent("d-input")!
  const _component_d_btn = _resolveComponent("d-btn")!
  const _component_d_snackbar = _resolveComponent("d-snackbar")!
  const _component_d_checkbox = _resolveComponent("d-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "list-point-badge drv-bg-color-n100" }, "1", -1)),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(_unref(ETelematicsMessagesKeys).GORILLA_SAFETY_POINT_1_TITLE)), 1)
      ]),
      (showDot.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_d_input, {
              ref_key: "dotNumberControl",
              ref: dotNumberControl,
              modelValue: dotNumber.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dotNumber).value = $event)),
              disable: _ctx.disable || isLoading.value || requestAccessIsSent.value,
              "reactive-rules": "",
              label: _ctx.$t(_unref(EInsurerMessagesKeys).DOT_TITLE),
              placeholder: _ctx.$t(_unref(EInsurerMessagesKeys).DOT_PLACEHOLDER),
              rules: [
            _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
            _unref(regexpValidator)(
              _unref(DOT_REGEXP),
              _ctx.$t(_unref(EInsurerMessagesKeys).VALIDATORS_DOT_COMMON_MESSAGE)
            ),
            _unref(skipOnEmptyValidator)(dotNumber.value, [
              _unref(minLengthValidator)(
                2,
                _ctx.$t(_unref(ECommonMessages).MIN_LENGTH_ERROR, { length: 2 })
              ),
              _unref(maxLengthValidator)(
                8,
                _ctx.$t(_unref(ECommonMessages).MAX_LENGTH_ERROR, { length: 10 })
              ),
              _unref(regexpValidator)(
                _unref(DOT_REGEXP),
                _ctx.$t(_unref(EInsurerMessagesKeys).VALIDATORS_DOT_COMMON_MESSAGE)
              ),
            ]),
          ]
            }, null, 8, ["modelValue", "disable", "label", "placeholder", "rules"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (requestAccessIsSent.value)
            ? (_openBlock(), _createBlock(_component_d_btn, {
                key: 0,
                variant: "secondary",
                label: 
              _ctx.$t(
                _unref(ETelematicsMessagesKeys).GORILLA_SAFETY_POINT_1_BUTTON_DONE_TITLE
              )
            ,
                icon: "circle-check",
                class: "drv-bg-color-g400 drv-color-n0"
              }, null, 8, ["label"]))
            : (_openBlock(), _createBlock(_component_d_btn, {
                key: 1,
                variant: "primary",
                disable: 
              _ctx.disable ||
              step1Loading.value ||
              isLoading.value ||
              requestAccessIsSent.value ||
              hasErrorStep1.value
            ,
                loading: step1Loading.value,
                onClick: onClickToActivateConnection,
                label: 
              _ctx.$t(_unref(ETelematicsMessagesKeys).GORILLA_SAFETY_POINT_1_BUTTON_TITLE)
            ,
                icon: "arrow-up-right"
              }, null, 8, ["disable", "loading", "label"]))
        ]),
        (showRequestAccessError.value)
          ? (_openBlock(), _createBlock(_component_d_snackbar, {
              key: 0,
              icon: "triangle-exclamation",
              class: "drv-bg-color-r100 drv-color-r600 drv-mt-6 drv-mb-2",
              message: _ctx.$t(_unref(ETelematicsMessagesKeys).GORILLA_SAFETY_ERROR_DOT)
            }, null, 8, ["message"]))
          : _createCommentVNode("", true)
      ]),
      (requestAccessIsSent.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_7, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "list-point-badge drv-bg-color-n100" }, "2", -1)),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t(_unref(ETelematicsMessagesKeys).GORILLA_SAFETY_POINT_2_TITLE)), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(HelpLink, {
                link: _ctx.$t(currentText.url),
                class: "col-12 drv-pb-2"
              }, null, 8, ["link"]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_d_checkbox, {
                  class: "drv-embeded-checkbox drv-form-control-adaptive",
                  modelValue: connectionApproved.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((connectionApproved).value = $event)),
                  disable: _ctx.disable || isLoading.value,
                  onClick: onConnectionApprovedClick,
                  label: 
                _ctx.$t(
                  _unref(ETelematicsMessagesKeys).GORILLA_SAFETY_POINT_2_CHECKBOX_TITLE
                )
              
                }, null, 8, ["modelValue", "disable", "label"])
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      (requestAccessIsSent.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_11, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "list-point-badge drv-bg-color-n100" }, "3", -1)),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t(_unref(ETelematicsMessagesKeys).GORILLA_SAFETY_POINT_3_TITLE)), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(CheckConnection, {
                modelValue: connected.value,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((connected).value = $event)),
                  onUpdateConnected
                ],
                loading: isLoading.value,
                "onUpdate:loading": _cache[3] || (_cache[3] = ($event: any) => ((isLoading).value = $event)),
                "is-model-fullfiled": connectionApproved.value,
                "platform-type": _ctx.platform.const,
                url: _ctx.platform.methods[0].url,
                creds: model.value,
                "hidden-clear-button": "",
                "hidden-notification": ""
              }, null, 8, ["modelValue", "loading", "is-model-fullfiled", "platform-type", "url", "creds"])
            ]),
            (showConnectedError.value)
              ? (_openBlock(), _createBlock(_component_d_snackbar, {
                  key: 0,
                  icon: "triangle-exclamation",
                  class: "drv-bg-color-r100 drv-color-r600 drv-mt-4 drv-mb-2",
                  message: 
            _ctx.$t(_unref(ETelematicsMessagesKeys).GORILLA_SAFETY_ERROR_CHECK_CONNECTION)
          
                }, null, 8, ["message"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})